import { z } from 'zod';

/**
 * Berichtsjablonen zoals ze over de lijn komen (`02-api-contract.md`
 * §Notificaties). Elk schema volgt de API; de schermen zien alleen het model uit
 * `model.ts`.
 */

/** Eén regel uit `GET /notification-templates`: één bericht op één kanaal. */
export const notificationTemplateEntrySchema = z.object({
    key: z.string(),
    key_label: z.string(),
    channel: z.string(),
    channel_label: z.string(),
    locale: z.string(),
    audience: z.string(),
    subject: z.string().nullable(),
    body: z.string(),
    /** `tenant` · `platform` · `built_in`. */
    source: z.string(),
    is_platform_default: z.boolean(),
    /** De rij die deze tekst draagt; `null` bij de ingebouwde tekst. */
    uuid: z.string().nullable(),
    /** Alleen bij een eigen tekst van het bedrijf. */
    updated_at: z.string().nullable(),
    default_subject: z.string().nullable(),
    default_body: z.string(),
    variables: z.array(z.string()),
    variable_labels: z.record(z.string(), z.string()),
    max_body_length: z.number(),
});

export type NotificationTemplateEntry = z.infer<typeof notificationTemplateEntrySchema>;

/** (`Notifications\NotificationTemplateResource`) wat opslaan teruggeeft. */
export const notificationTemplateResourceSchema = z.object({
    uuid: z.string(),
    key: z.string(),
    channel: z.string(),
    subject: z.string().nullable(),
    body: z.string(),
    is_platform_default: z.boolean(),
    updated_at: z.string().nullable(),
});

export type NotificationTemplateResource = z.infer<typeof notificationTemplateResourceSchema>;

/** (`Notifications\NotificationTemplatePreviewResource`) */
export const notificationTemplatePreviewResourceSchema = z.object({
    key: z.string(),
    channel: z.string(),
    subject: z.string().nullable(),
    body: z.string(),
    /** Het volledige maildocument in de huisstijl; `null` bij een sms. */
    html: z.string().nullable(),
    text: z.string().nullable(),
    values: z.record(z.string(), z.string()),
});

export type NotificationTemplatePreviewResource = z.infer<
    typeof notificationTemplatePreviewResourceSchema
>;

/** (`Notifications\NotificationTestMailResource`) */
export const notificationTestMailResourceSchema = z.object({
    recipient: z.string(),
    used_platform_fallback: z.boolean(),
});

export type NotificationTestMailResource = z.infer<typeof notificationTestMailResourceSchema>;
